import get from "lodash/get";
import trim from "lodash/trim";

import { BALANCES } from "./constants";

export const getLocale = (value: number, id: number) => {
  return trim(`${value.toLocaleString("ru-RU")} ${get(BALANCES, id, "")}`);
};

export const getIsMonitor = () => {
  const url = new URLSearchParams(window.location.search);

  let result = true;

  if (url.has("monitor")) {
    const monitor = url.get("monitor");
    result = monitor === "false" ? true : false;
  }

  return result;
};

export const getSoundMuted = () => {
  const url = new URLSearchParams(window.location.search);

  let soundMuted = 1;

  if (url.has("sound_muted")) {
    soundMuted = parseInt(url.get("sound_muted") || "1");
  }

  return soundMuted;
};

/**
 * Метод генерации data-testid
 * @param testId - testId элемента
 * @returns - объект с testId
 */
export const getDataTestId = (testId: string) => {
  const result: Record<string, string> = {};

  if (
    !document.URL.includes("https://stage-race-user.offline.liverace.tech/") &&
    !document.URL.includes("https://prod-race-user.offline.liverace.tech/")
  ) {
    result["data-testid"] = testId;
  }

  return result;
};

const DEFAULT_TARGET_ORIGIN = "https://betboom.ru";

/**
 * Сообщение о событии создания ставки для postMessage
 */
export const CREATE_BET_EVENT = {
  route: "actions",
  data: {
    event: "CREATE_BET",
  },
};

/**
 * Отправка сообщения в родительское окно через postMessage
 * @param message - данные для отправки
 */
export const sendPostMessage = (message: unknown): void => {
  const isProd = window.location.hostname.includes("prod-liverace-user");

  if (isProd) {
    window.top?.postMessage(JSON.stringify(message), DEFAULT_TARGET_ORIGIN);
  } else {
    window.top?.postMessage(JSON.stringify(message), "*");
  }
};
